module.exports = __webpack_public_path__ + "media/2025.aa5b4a62.mp4";